import React from 'react';
import { Link, useParams } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import { translations } from '../../translations';

const Footer = () => {
  const { lang = 'nl' } = useParams();
  const t = translations[lang] || translations.nl;

  const links = {
    platform: [
      { name: lang === 'nl' ? 'Testament Scan' : 'Estate Assessment', path: `/${lang}/scan` },
      { name: t.nav.howItWorks, path: `/${lang}/${lang === 'nl' ? 'hoe-het-werkt' : 'how-it-works'}` },
      { name: lang === 'nl' ? 'Tools & Calculators' : 'Tools & Calculators', path: `/${lang}/tools` },
      { name: t.nav.international, path: `/${lang}/${lang === 'nl' ? 'internationaal' : 'international'}` },
    ],
    kennis: [
      { name: t.nav.situations, path: `/${lang}/${lang === 'nl' ? 'situaties' : 'situations'}` },
      { name: t.nav.knowledge, path: `/${lang}/${lang === 'nl' ? 'kennisbank' : 'insights'}` },
      { name: t.nav.faq, path: `/${lang}/faq` },
      { name: t.situations.items.blended.title, path: `/${lang}/${lang === 'nl' ? 'situaties/samengesteld-gezin' : 'situations/blended-family'}` },
      { name: t.situations.items.entrepreneur.title, path: `/${lang}/${lang === 'nl' ? 'situaties/ondernemer' : 'situations/entrepreneur'}` },
    ],
    bedrijf: [
      { name: lang === 'nl' ? 'Over ons' : 'About us', path: `/${lang}/${lang === 'nl' ? 'over-ons' : 'about-us'}` },
      { name: t.footer.contact, path: `/${lang}/contact` },
      { name: t.footer.privacy, path: `/${lang}/privacy` },
      { name: t.footer.cookies, path: `/${lang}/cookies` },
      { name: t.footer.terms, path: `/${lang}/${lang === 'nl' ? 'algemene-voorwaarden' : 'terms'}` },
      { name: t.footer.disclaimer, path: `/${lang}/disclaimer` },
    ]
  };

  return (
    <footer className="bg-navy-950 text-white pt-24 pb-12">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-20">
          <div className="col-span-1">
            <Link to={`/${lang}`} className="flex items-center gap-2.5 mb-6">
              <div className="w-9 h-9 bg-white/10 rounded-xl flex items-center justify-center border border-white/10">
                <SafeIcon name="Shield" className="text-white text-lg" />
              </div>
              <span className="font-bold text-xl tracking-tight">Testamentair</span>
            </Link>
            <p className="text-sm text-slate-400 leading-relaxed mb-8 max-w-xs">
              {t.footer.desc}
            </p>
            <div className="flex gap-4">
              <a href="https://www.linkedin.com/company/testamentair/" target="_blank" rel="noopener noreferrer" className="w-8 h-8 rounded-full bg-white/5 flex items-center justify-center hover:bg-white/10 transition-colors cursor-pointer border border-white/5">
                <SafeIcon name="Linkedin" className="text-xs text-slate-300" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-bold text-white mb-6 text-sm uppercase tracking-widest">{t.footer.platform}</h4>
            <ul className="space-y-4">
              {links.platform.map(l => (
                <li key={l.name}>
                  <Link to={l.path} className="text-sm text-slate-400 hover:text-white transition-colors relative after:absolute after:bottom-0 after:left-0 after:w-0 after:h-px after:bg-white after:transition-all hover:after:w-full">
                    {l.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-white mb-6 text-sm uppercase tracking-widest">{t.footer.knowledge}</h4>
            <ul className="space-y-4">
              {links.kennis.map(l => (
                <li key={l.name}>
                  <Link to={l.path} className="text-sm text-slate-400 hover:text-white transition-colors relative after:absolute after:bottom-0 after:left-0 after:w-0 after:h-px after:bg-white after:transition-all hover:after:w-full">
                    {l.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-white mb-6 text-sm uppercase tracking-widest">{t.footer.company}</h4>
            <ul className="space-y-4">
              {links.bedrijf.map(l => (
                <li key={l.name}>
                  <Link to={l.path} className="text-sm text-slate-400 hover:text-white transition-colors relative after:absolute after:bottom-0 after:left-0 after:w-0 after:h-px after:bg-white after:transition-all hover:after:w-full">
                    {l.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="pt-12 border-t border-white/5 flex flex-col gap-6 items-center text-center">
          <p className="text-[10px] uppercase font-bold tracking-[0.2em] text-slate-500">
            {t.footer.legalNote}
          </p>
          <p className="text-xs text-slate-600">
            &copy; {new Date().getFullYear()} Testamentair.com — {t.footer.rights}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;